import { types } from 'mobx-state-tree';
import Integration from '../../models/integration/integration';
import * as views from './integrationsStoreViews';
import * as actions from './integrationsStoreActions';

const IntegrationsStore = types
  .model('IntegrationsStore', {
    integrations: types.optional(
      types.array(Integration), []
    ),
    updating: types.optional(types.boolean, false),
    loading: types.optional(types.boolean, false), // Added loading state similar to timeSlotsStore
  })
  .views(views.integrationsStoreViews)
  .actions(actions.integrationsStoreActions);

export default IntegrationsStore;
